import { applySpec, prop } from 'ramda';

/** @enum */
const Contract = {
	Brand: 'BRAND',
	BrandId: 'BRAND_ID',
	Model: 'MODEL',
	Defect: 'DEFECT',
	SerialNumber: 'SERIAL',
}

/**
 * @typedef { object } Device
 * @property { string } brand
 * @property { string } brandId
 * @property { string } model
 * @property { string } defect
 * @property { string } serialNumber
 */

export default applySpec({
	brand: prop(Contract.Brand),
	brandId: prop(Contract.BrandId),
	model: prop(Contract.Model),
	defect: prop(Contract.Defect),
	serialNumber: prop(Contract.SerialNumber),
});
